import { useEffect, useState, useContext, useCallback } from 'react';
import { localStorage, ViewerContext } from 'dash-ui';
import { useGetFullAccountQuery } from 'gql/generated.graphql';

const useInitViewer = () => {
  const [isReady, setIsReady] = useState(false);
  const { tokens, setAccount, setProfile, setTokens } =
    useContext(ViewerContext);
  const { accessToken } = tokens;
  const {
    loading: isViewerLoading,
    data: accountData,
    error,
  } = useGetFullAccountQuery({ skip: !accessToken });
  const account = accountData?.getAccount;

  useEffect(() => {
    if (!isViewerLoading) {
      if (account && setAccount) {
        setAccount(account);
      }
      if (account?.profile && setProfile) {
        setProfile(account?.profile);
      }
      if (error) {
        console.error('---useInitUser -->', error);
      }
      setIsReady(true);
    }
  }, [isViewerLoading, setAccount, setProfile, account, error]);

  const onLocalStorageChanged = useCallback(() => {
    if (setTokens) {
      setTokens({
        accessToken: localStorage.getAccessToken() || '',
        refreshToken: localStorage.getRefreshToken() || '',
        refreshTokenExpiry: localStorage.getRefreshTokenExpiry() || '',
      });
    }
  }, [setTokens]);

  useEffect(() => {
    window.addEventListener('storage', onLocalStorageChanged);
    return () => {
      window.removeEventListener('storage', onLocalStorageChanged);
    };
  }, [onLocalStorageChanged]);
  return [isReady];
};
export default useInitViewer;
